// The game day is anchored to UK local time (Europe/London) — matching the
// server's `today()`. Using the IANA zone handles GMT⇄BST and DST for free.
// This is the single source of truth for "what day is it" on the client.
const GAME_TZ = 'Europe/London';
const dateFmt = new Intl.DateTimeFormat('en-CA', {
  timeZone: GAME_TZ,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

/** Today's UK calendar date as YYYY-MM-DD. `now` is injectable for testing. */
export function londonToday(now: Date = new Date()): string {
  return dateFmt.format(now); // en-CA → YYYY-MM-DD
}

/** Shift a YYYY-MM-DD label by whole days (timezone-independent label math). */
export function addDays(isoDate: string, days: number): string {
  const d = new Date(`${isoDate}T00:00:00.000Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}
